import { service } from '../index.js';

const resource = process.env.VUE_APP_RESOURCE_SICUDBPM_OWN_TASK;

export default {
  put(payload) {
    return service.put(resource, payload);
  }
};
